var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-6 pb-7 bg-gradient-success"}),(Object.keys(_vm.survey).length)?_c('survey-creator',{attrs:{"elements":_vm.survey.elements,"id":_vm.survey.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }